import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CarouselControl, CarouselItem, Modal, ModalFooter } from 'reactstrap';

import slide1 from '~/assets/img/prazo1.png';
import slide2 from '~/assets/img/prazo2.png';
import slide3 from '~/assets/img/prazo3.png';

import api from '~/services/api';
import toast from 'react-hot-toast';
import formatValue from '~/services/formatValue';
import { useAuth } from '~/context/AuthContext';
import { Tooltip } from 'ui-kit-takeat';
import {
  Checkbox as ChecboxUI,
  IconClose,
  IconPlus,
  IconSearch,
  Input as InputUI,
  IconInfoFilled,
  IconCached,
  Button as ButtonUI,
  Button,
  Calendar,
  IconDownload,
} from 'takeat-design-system-ui-kit';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import api2 from '~/services/api2';
import GetDemoButton from '~/components/Buttons/GetDemoButton';
import IconPrazo from '~/assets/img/icon-a-prazo.svg';
import { Controller, useForm } from 'react-hook-form';
import CreditRegisterItem from './CreditRegisterItem';
import {
  Container,
  Header,
  DatePickerStyledUnify,
  CarouselStyled,
  CarouselControlStyled,
  CarouselIndicatorsStyled,
  TitleTerm,
  TitleHeader,
  PrazoHeaderSection,
  TitleSale,
  CrdWhite,
  CardItems,
  ItemIcon,
  ItemInfo,
  NumberPrice,
  CardCheckbox,
  ItemCheckbox,
  Therm,
  TitleCheckbox,
  CardItemsCheckbox,
  ListWhite,
  TheadTitle,
  TrTitle,
  HeaderAccount,
  ButtonsInfo,
  InputInfo,
  ButtonAtt,
  ThTitle,
  TBodyInfo,
  ModalBodyy,
  FormFields,
  FieldInput,
  HeaderForm,
  StyledModal,
  TextTooltip,
  ToolTipModal,
  FooterModal,
  CalendarInfo,
  NoAccount,
} from './styles';

function CreditRegister() {
  const [registerCredits, setRegisterCredits] = useState([]);
  const { user, updateUser } = useAuth();
  const [isModalRegisterAccountOpened, setIsModalRegisterAccountOpened] =
    useState(false);
  const [creditRegisterWthNfce, setCreditRegisterWthNfce] = useState(
    user?.credit_register_with_nfce
  );
  const [isSubmittingProfile, setIsSubmittingProfile] = useState(false);

  async function handleSubmitProfile(data) {
    if (isSubmittingProfile) return;
    setIsSubmittingProfile(true);
    try {
      const updateProfile = {
        credit_register_with_nfce: !data,
      };

      await updateUser(updateProfile);
    } catch (error) {
      toast.error('Falha ao atualizar o perfil do restaurante.');
      setCreditRegisterWthNfce(!creditRegisterWthNfce);
    } finally {
      setIsSubmittingProfile(false);
    }
  }

  useEffect(() => {
    setCreditRegisterWthNfce(user?.credit_register_with_nfce);
  }, [user.credit_register_with_nfce]);

  const {
    reset: resetCadastro,
    handleSubmit: handleSubmitRecordForm,
    register: registerRecord,
    control: controlRecord,
    formState: { errors: errorsRecord },
  } = useForm();

  function toggleModalRegisterAccount() {
    setIsModalRegisterAccountOpened(!isModalRegisterAccountOpened);
    resetCadastro();
  }

  const [expiresAt, setExpiresAt] = useState('');

  const handleSubmit = useCallback(
    async (RecordSubmitData) => {
      try {
        const response = await api.post('/restaurants/credit-register', {
          name: RecordSubmitData.name,
          phone: RecordSubmitData.phone,
          cnpj: RecordSubmitData.cnpj,
          expires_at: expiresAt || null,
          total_limit: RecordSubmitData.total_limit || null,
        });

        toast.success('Conta cadastrada com sucesso!');

        setIsModalRegisterAccountOpened(false);

        const newRegister = {
          ...response.data,
          credit_register_items: response.data.credit_register_items || [],
        };

        const newRegisters = [...registerCredits, newRegister];

        setRegisterCredits(newRegisters);
      } catch (error) {
        toast.error('Erro ao criar conta');
      }
    },
    [expiresAt, registerCredits]
  );

  const inputAccountRef = useRef(null);

  const [accountSelected, setAccountSelected] = useState([]);

  function handleSelectAccount(id) {
    if (accountSelected.includes(id)) {
      setAccountSelected([]);
    } else {
      setAccountSelected([id]);
    }
  }

  const [registerCreditFiltered, setRegisterCreditFiltered] = useState([]);

  function handleSearchInputAccount(e) {
    const accountFind =
      registerCredits.filter((item) =>
        item.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            e
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
          )
      ).length > 0
        ? registerCredits.filter((item) =>
            item.name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .includes(
                e
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
              )
          )
        : registerCredits.filter((item) => item.phone.includes(e.toString()));
    setRegisterCreditFiltered(accountFind);
  }

  const [totalRegisterToReceive, setTotalRegisterToReceive] = useState(0);
  const [clientSubmit, setClientSubmit] = useState(false);

  const getCreditRegisters = useCallback(async () => {
    try {
      const response = await api.get(
        '/restaurants/credit-register?details=true'
      );
      const orderedCredits = response.data.sort(
        (a, b) => Number(a.balance) - Number(b.balance)
      );

      const totals = response.data
        .map((item) => item.credit_register_items)
        .filter((item) => item.length > 0)
        .map((item) =>
          item.reduce((acum, item) => acum + Number(item.value), 0)
        );
      const sum = totals.reduce((total, value) => total + value, 0);

      setTotalRegisterToReceive(Math.abs(sum));
      setRegisterCredits(orderedCredits);

      if (clientSubmit) {
        toast.success('Atualização realizada com sucesso!');
        setClientSubmit(false);
      }
    } catch (error) {
      toast.error('Erro ao baixar contas a prazo');
    }
  }, [clientSubmit]);

  useEffect(() => {
    getCreditRegisters();
  }, [getCreditRegisters]);

  const [paymentMethodsOptions, setPaymentMethodsOptions] = useState([]);

  const getPaymentMethods = useCallback(async () => {
    const response = await api.get('/restaurants/cash-flows/payment-methods');

    const methods = response.data.map((method) => {
      return {
        label: method.name,
        value: method.id,
      };
    });

    setPaymentMethodsOptions(methods);
  }, []);

  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);

  const [banks, setBanks] = useState([]);

  const getBanks = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/cash-flows/bank-accounts');

      const banksOptions = response.data.map((bank) => {
        return {
          label: bank.name,
          value: bank.id,
        };
      });

      setBanks(banksOptions);
    } catch (error) {
      toast.error('Erro ao baixar contas');
    }
  }, []);

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  // banner atualizações
  // modal carousel

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const items = [
    {
      src: slide1,
    },
    {
      src: slide2,
    },
    {
      src: slide3,
    },
  ];

  const nextButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previousButton = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  // Carousel Item Data
  const carouselItemData = items.map((item, index) => {
    return (
      <CarouselItem
        key={index}
        onExited={() => setAnimating(false)}
        onExiting={() => setAnimating(true)}
        active={index === activeIndex}
      >
        <img src={item.src} alt={item.altText} />
      </CarouselItem>
    );
  });
  const bannerStorage = JSON.parse(
    localStorage.getItem('@gddashboard:bannerFeatRegisterAccount')
  );

  const [isBannerOpened, setIsBannerOpened] = useState(
    bannerStorage === null ? true : bannerStorage
  );

  function toggleModalUpdateBanner() {
    setIsBannerOpened(false);
  }

  function handleConfirmAndCloseModal() {
    setIsBannerOpened(false);
    localStorage.setItem('@gddashboard:bannerFeatRegisterAccount', false);
  }

  // validar acesso

  const [permission, setPermission] = useState(false);

  const validateUser = useCallback(async () => {
    try {
      const response = await api2.get(
        '/restaurants/users/role-permission/FinanceCreditRegister'
      );

      const { can_read } = response.data.FinanceCreditRegister;

      setPermission(can_read);
    } catch (error) {
      toast.error('Erro ao solicitar acesso');
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  const [unidadeTooltip, setUnidadeTooltip] = useState(false);
  const [tooltipCalendar, setToolTipCalendar] = useState({
    checkbox: false,
    calendar: false,
  });

  const [checkSpread, setCheckSpread] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const date = new Date(2025, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date(2025, 11, 31);
    date.setHours(23, 59, 59, 999);
    return date;
  });
  const spreadSheet = useCallback(async () => {
    console.log('datas', startDate, endDate);
    try {
      const response = await api.get(
        `/restaurants/credit-registers/xlsx?start_date=${startDate}&end_date=${endDate}`,
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const sheetLink = document.createElement('a');
      sheetLink.href = url;
      sheetLink.setAttribute('download', 'planilha-conta-a-prazo.xls');
      document.body.appendChild(sheetLink);
      sheetLink.click();
      sheetLink.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar planilha:', error);
      toast.error('Erro ao baixar planilha');
    }
  }, [startDate, endDate]);

  return permission ? (
    <Container>
      <Modal
        isOpen={isBannerOpened}
        toggle={toggleModalUpdateBanner}
        style={{ padding: 0 }}
      >
        <CarouselStyled
          activeIndex={activeIndex}
          next={nextButton}
          previous={previousButton}
          interval={20000}
        >
          {carouselItemData}

          <CarouselControlStyled
            direction="prev"
            directionText="Previous"
            onClickHandler={previousButton}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={nextButton}
          />
        </CarouselStyled>
        <CarouselIndicatorsStyled
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              toggleModalUpdateBanner();
            }}
            variant="outlined"
          >
            Entendi
          </Button>
          <Button type="button" onClick={handleConfirmAndCloseModal}>
            Não desejo ver novamente
          </Button>
        </ModalFooter>
      </Modal>
      <Header>
        <TitleHeader>
          <TitleTerm>Conta a prazo</TitleTerm>
          <GetDemoButton url="https://app.getdemo.com.br/d/290574ef-84ae-4941-81ff-b77d87553a98" />
        </TitleHeader>

        <PrazoHeaderSection>
          <CrdWhite>
            <CardItems>
              <ItemIcon>
                <img src={IconPrazo} alt="imagem de icone a prazo" />
              </ItemIcon>
              <ItemInfo>
                <TitleSale className="card-category">
                  Saldo Total a Receber:
                </TitleSale>
                <NumberPrice>
                  {formatValue(parseFloat(totalRegisterToReceive).toFixed(2))}
                </NumberPrice>
              </ItemInfo>
            </CardItems>
          </CrdWhite>

          <CrdWhite $checkbox>
            <CardItemsCheckbox>
              <TitleSale>Configuração da conta a prazo</TitleSale>
              <CardCheckbox>
                {/* <ItemCheckbox>
                  <ChecboxUI
                    name="credit_register_with_nfce"
                  // onClick={() => {
                  //   handleSubmitProfile(creditRegisterWthNfce);
                  // }}
                  // checked={creditRegisterWthNfce}
                  />
                  <TitleCheckbox>Limitar uma única conta a prazo por comanda</TitleCheckbox>
                  <TooltipInfo
                    anchorSelect="#tooltipOne" place='right-start'
                  >Exemplo de tooltip</TooltipInfo>
                  <IconInfoFilled id="" fontSize={24} fill={'#7A7A7A'} />
                </ItemCheckbox> */}

                <ItemCheckbox>
                  <ChecboxUI
                    name="credit_register_with_nfce"
                    onClick={() => {
                      handleSubmitProfile(creditRegisterWthNfce);
                    }}
                    checked={creditRegisterWthNfce}
                    disabled={isSubmittingProfile}
                  />
                  <TitleCheckbox>
                    Habilitar a emissão da nota fiscal na quitação da conta a
                    prazo
                  </TitleCheckbox>
                  <IconInfoFilled
                    onMouseEnter={() => setUnidadeTooltip(true)}
                    onMouseLeave={() => setUnidadeTooltip(false)}
                    fontSize={24}
                    fill="#7A7A7A"
                  />
                  <Tooltip
                    show={unidadeTooltip}
                    content={
                      <p
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          fontWeight: 500,
                          lineHeight: '16px',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Ideal para emitir apenas uma NF no momento que a conta
                        for quitada.
                        <br />
                        <br />
                        <strong> Aviso!</strong> Se essa opção estiver
                        desmarcada, cuide para que as comandas não tenham
                        emissão duplicada ao finalizar e ao quitar a conta a
                        prazo.
                      </p>
                    }
                    containerStyles={{
                      padding: '8px 16px 8px 16px',
                      borderRadius: 8,
                      top: -113,
                      left: 335,
                      width: 366,
                      background: '#FFFFFF',
                      color: '#545454',
                      fontSize: 12,
                    }}
                  />
                </ItemCheckbox>

                <ItemCheckbox>
                  <ChecboxUI
                    name="planilha-prazo"
                    onClick={() => setCheckSpread(!checkSpread)}
                    checked={checkSpread}
                  />
                  <TitleCheckbox>
                    Habilitar o download da planilha conta a prazo
                  </TitleCheckbox>
                  <IconInfoFilled
                    onMouseEnter={() =>
                      setToolTipCalendar((prevState) => ({
                        ...prevState,
                        checkbox: true,
                      }))
                    }
                    onMouseLeave={() =>
                      setToolTipCalendar((prevState) => ({
                        ...prevState,
                        checkbox: false,
                      }))
                    }
                    fontSize={24}
                    fill="#7A7A7A"
                  />
                  <Tooltip
                    show={tooltipCalendar.checkbox}
                    content={
                      <p
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          fontWeight: 500,
                          lineHeight: '16px',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Disponibiliza a planilha da conta a prazo para download.
                      </p>
                    }
                    containerStyles={{
                      padding: '8px 16px 8px 16px',
                      borderRadius: 8,
                      top: -50,
                      left: 35,
                      width: 366,
                      background: '#FFFFFF',
                      color: '#545454',
                      fontSize: 12,
                    }}
                  />
                </ItemCheckbox>
              </CardCheckbox>
            </CardItemsCheckbox>
          </CrdWhite>
        </PrazoHeaderSection>

        {/* <Row>
          <Col style={{ paddingLeft: 0 }}>
            <MessageContainer>
              <p>
                <strong>MARCADO:</strong> Impossibilita adicionar mais de uma
                conta a prazo por comanda, mas permite a emissão de nota fiscal.
              </p>
              <p>
                <strong>NÃO MARCADO:</strong> Permite adicionar mais de uma
                conta a prazo por comanda, no entanto, impossibilita a emissão
                de nota fiscal, sendo possível apenas a emissão de nota avulsa.
              </p>
            </MessageContainer>
          </Col>
        </Row> */}
      </Header>

      {registerCredits && registerCredits.length > 0 ? (
        <ListWhite>
          <HeaderAccount>
            <ButtonsInfo>
              <InputInfo>
                <InputUI
                  name="account"
                  type="text"
                  placeholder="Nome / Telefone"
                  iconLeft={<IconSearch />}
                  iconRight={
                    <IconClose
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setRegisterCreditFiltered('');
                        inputAccountRef.current.value = '';
                      }}
                    />
                  }
                  onChange={(e) => {
                    handleSearchInputAccount(e.target.value);
                  }}
                  ref={inputAccountRef}
                />
              </InputInfo>
              <ButtonAtt>
                <ButtonUI
                  variant="text"
                  customColor=" #2EC9B7 "
                  isLoading={clientSubmit}
                  onClick={() => {
                    getCreditRegisters();
                    setClientSubmit(true);
                  }}
                  style={{
                    gap: 8,
                    alignItems: 'center',
                    textDecoration: 'none',
                  }}
                >
                  <IconCached isLoading={clientSubmit} fontSize={24} />{' '}
                  Atualizar
                </ButtonUI>
              </ButtonAtt>
            </ButtonsInfo>

            <CalendarInfo>
              {checkSpread && (
                <Therm>
                  <IconDownload
                    fontSize={28}
                    fill="#C8131B"
                    style={{ cursor: 'pointer' }}
                    onClick={spreadSheet}
                    onMouseEnter={() =>
                      setToolTipCalendar((prevState) => ({
                        ...prevState,
                        calendar: true,
                      }))
                    }
                    onMouseLeave={() =>
                      setToolTipCalendar((prevState) => ({
                        ...prevState,
                        calendar: false,
                      }))
                    }
                  />
                  <Tooltip
                    show={tooltipCalendar.calendar}
                    content={
                      <span
                        style={{
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          fontWeight: 500,
                          lineHeight: '16px',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Baixar planilha
                      </span>
                    }
                    containerStyles={{
                      padding: '8px 16px 8px 16px',
                      borderRadius: 8,
                      top: -35,
                      left: -50,
                      width: 130,
                      background: '#FFFFFF',
                      color: '#545454',
                      fontSize: 12,
                    }}
                  />
                  <Calendar
                    onlyDate
                    onSelectDate={(e) => {
                      setStartDate(e.start);
                      setEndDate(e.end);
                    }}
                  />
                </Therm>
              )}
              <Button
                style={{ width: 200 }}
                icon={<IconPlus fontSize={24} fill=" #C8131B " />}
                onClick={toggleModalRegisterAccount}
              >
                Cadastrar Conta
              </Button>
            </CalendarInfo>
          </HeaderAccount>

          <TheadTitle>
            <TrTitle $trNameAccount>
              <ThTitle>Nome da conta</ThTitle>
            </TrTitle>
            <TrTitle>
              <ThTitle>Telefone</ThTitle>
            </TrTitle>
            <TrTitle>
              <ThTitle>Valor Consumido</ThTitle>
            </TrTitle>
            <TrTitle>
              <ThTitle>Limite de Crédito</ThTitle>
            </TrTitle>
            <TrTitle $trNameAction>
              <ThTitle>Ações</ThTitle>
            </TrTitle>
          </TheadTitle>

          <TBodyInfo>
            {registerCreditFiltered && registerCreditFiltered.length > 0
              ? registerCreditFiltered.map((item) => (
                  <CreditRegisterItem
                    key={item.id}
                    getCreditRegisters={getCreditRegisters}
                    item={item}
                    registerCredits={registerCreditFiltered}
                    setRegisterCredits={setRegisterCreditFiltered}
                    accountSelected={accountSelected}
                    handleSelectAccount={handleSelectAccount}
                    setTotalRegisterToReceive={setTotalRegisterToReceive}
                    paymentMethodsOptions={paymentMethodsOptions}
                    banks={banks}
                  />
                ))
              : registerCredits &&
                registerCredits.length > 0 &&
                registerCredits.map((item) => (
                  <CreditRegisterItem
                    getCreditRegisters={getCreditRegisters}
                    item={item}
                    key={item.id}
                    registerCredits={registerCredits}
                    setRegisterCredits={setRegisterCredits}
                    accountSelected={accountSelected}
                    handleSelectAccount={handleSelectAccount}
                    setTotalRegisterToReceive={setTotalRegisterToReceive}
                    paymentMethodsOptions={paymentMethodsOptions}
                    banks={banks}
                  />
                ))}
          </TBodyInfo>
        </ListWhite>
      ) : (
        <ListWhite $noAccount>
          <NoAccount>
            <ThTitle>Não há clientes cadastrados no momento.</ThTitle>
          </NoAccount>
          <HeaderAccount $noAccount>
            <CalendarInfo>
              <Button
                style={{ width: 194 }}
                icon={<IconPlus fontSize={24} fill=" #C8131B " />}
                onClick={toggleModalRegisterAccount}
              >
                Cadastrar Conta
              </Button>
            </CalendarInfo>
          </HeaderAccount>
        </ListWhite>
      )}

      <StyledModal
        isOpen={isModalRegisterAccountOpened}
        toggle={toggleModalRegisterAccount}
      >
        <HeaderForm>
          <TitleSale $titleModal>Cadastrar Conta</TitleSale>
          <IconClose
            color="#545454"
            fontSize={24}
            onClick={toggleModalRegisterAccount}
            cursor="pointer"
          />
        </HeaderForm>
        <form onSubmit={handleSubmitRecordForm(handleSubmit)}>
          <ModalBodyy>
            <FormFields>
              <FieldInput>
                <InputUI
                  style={{ width: '100%' }}
                  label="Nome da conta "
                  name="name"
                  control={controlRecord}
                  register={registerRecord('name', {
                    required: 'Nome é obrigatório',
                  })}
                  error={errorsRecord.name?.message?.toString()}
                />
              </FieldInput>
              <FieldInput>
                <Controller
                  name="phone"
                  control={controlRecord}
                  rules={{
                    required: 'Número é obrigatório',
                  }}
                  render={({ field }) => (
                    <InputUI
                      {...field}
                      style={{ width: '100%' }}
                      placeholder="(xx) x xxxx-xxxx"
                      label="Telefone"
                      mask="(99) 99999-9999"
                      error={errorsRecord.phone?.message?.toString()}
                    />
                  )}
                />
              </FieldInput>
            </FormFields>
            <FormFields>
              <InputUI
                style={{ width: '100%' }}
                label="CPF/ CNPJ"
                name="cnpj"
                control={controlRecord}
                register={registerRecord('cnpj', {})}
              />
            </FormFields>
            <FormFields style={{ borderBottom: '1px solid #EDEDED' }}>
              <FieldInput>
                <TitleSale>Validade do saldo</TitleSale>
                <DatePickerStyledUnify
                  locale="pt"
                  style={{ borderColor: '#C8131B' }}
                  name="expires_at"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="__/__/____"
                  onChange={(date) => setExpiresAt(date)}
                  selected={expiresAt}
                />
                <ToolTipModal>
                  <IconInfoFilled
                    id="tooltipOne"
                    fontSize={18}
                    fill="#7A7A7A"
                  />
                  <TextTooltip> Se vazio, não haverá data limite.</TextTooltip>
                </ToolTipModal>
              </FieldInput>
              <FieldInput style={{ marginTop: '-2px' }}>
                <InputUI
                  isCurrency
                  label="Limite de Crédito"
                  name="total_limit"
                  control={controlRecord}
                  register={registerRecord('total_limit', {})}
                />
                <ToolTipModal>
                  <IconInfoFilled
                    id="tooltipOne"
                    fontSize={18}
                    fill="#7A7A7A"
                  />
                  <TextTooltip>
                    {' '}
                    Se vazio, o saldo não será limitado.
                  </TextTooltip>
                </ToolTipModal>
              </FieldInput>
            </FormFields>
          </ModalBodyy>

          <FooterModal>
            <Button customColor="#2ec9b7" type="submit">
              Cadastrar
            </Button>
          </FooterModal>
        </form>
      </StyledModal>
    </Container>
  ) : (
    <PermissionErrorContainer />
  );
}

export default CreditRegister;
